export class AssetCategory {
    id: number;
    code: string;
    name: string;
    state: any;
}